class RegexValue {
  onlyInteger = /^[0-9]+$/;
  onlyNumbers = /^[0-9,.]+$/;
  guid = /^(\{{0,1}([0-9a-fA-F]){8}-([0-9a-fA-F]){4}-([0-9a-fA-F]){4}-([0-9a-fA-F]){4}-([0-9a-fA-F]){12}\}{0,1})$/;
  email = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,}$/;
}

export const regexValue = new RegexValue();
